import { asyncRoutes, constantRoutes } from "@/router/index";
import router from "@/router/index";

/**
 * 过滤路由
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * 过滤路由
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, roles, options) {
  
  const res = [];
  // console.log("routes", routes)
  for(let route of routes) {
    if (!options.show_special && route?.is_special) {
      continue
    }
    if (route?.is_buyer && !options.show_buyer) {
      continue
    }
    if (route?.is_buyer_booth && !options.show_booth) {
      continue
    }
    
    if (hasPermission(roles, route)) {
      if (route.children) {
        route.children = filterAsyncRoutes(route.children, roles, options);
        // Handle schedule routes - when both are available, only show one in menu
        if (options.show_buyer && options.show_booth) {
          const scheduleRoutes = route.children.filter(child => 
            child.path === 'schedule' || child.path === 'scheduleBooth'
          );
          if (scheduleRoutes.length === 2) {
            // Hide scheduleBooth from menu but keep it accessible
            const scheduleBoothRoute = route.children.find(child => child.path === 'scheduleBooth');
            if (scheduleBoothRoute) {
              scheduleBoothRoute.hidden = true;
            }
          }
        }
      }
      res.push(route);
    }
  }
  // routes.forEach((route) => {
  //   if (hasPermission(roles, route)) {
  //     if (route.children) {
  //       route.children = filterAsyncRoutes(route.children, roles);
  //     }
  //     res.push(route);
  //   }
  // });
  return res;
}

const state = {
  routes: [],
  hasAuth: false,
  removeRoutes: [], // 用于删除动态路由
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    let get_routes = [...routes]
    // get_routes = get_routes.filter((item) => {
    //   return item.path !== '/en/profile'
    // })
    // console.log("get_routesget_routesget_routesget_routes", get_routes)
    state.routes = constantRoutes.concat(get_routes);
  },
  HAS_AUTH: (state, val) => {
    state.hasAuth = val
  },
  SET_REMOVE_ROUTES: (state, routes) => {
    state.removeRoutes = routes;
  },
};
const actions = {
  generateRoutes({ dispatch, commit, rootState }) {
    const roles = rootState.user.roles;
    const show_special_menu = rootState.user.show_special_menu;
    const show_buyer = rootState.user.precise_match_buyer_open;
    const show_booth = rootState.user.precise_match_booth_open;
    // console.log('----show_special_menu',show_special_menu, 'show_buyer: ', show_buyer, 'show_booth: ', show_booth);
    
    return new Promise((resolve) => {
      let accessedRoutes;
      const rolesArray = roles || [];
      // if (rolesArray.includes("visitor")) {
      //   accessedRoutes = asyncRoutes || [];
      // } else {
        // accessedRoutes = filterAsyncRoutes(asyncRoutes, rolesArray, {show_special: show_special_menu, show_buyer, show_booth});
      // }
      accessedRoutes = filterAsyncRoutes(asyncRoutes, rolesArray, {show_special: show_special_menu, show_buyer, show_booth});
      console.log("accessedRoutes",accessedRoutes);
      commit("SET_ROUTES", accessedRoutes);
      commit("HAS_AUTH", true);
      dispatch("addRoutes", accessedRoutes);
      resolve(accessedRoutes);
    });
  },
  addRoutes({ commit }, accessRoutes) {
    // 添加动态路由，同时保存移除函数，将来如果需要重置路由可以用到它们
    const removeRoutes = [];
    accessRoutes.forEach((route) => {
      const removeRoute = router.addRoute(route);
      removeRoutes.push(removeRoute);
    });
    commit("SET_REMOVE_ROUTES", removeRoutes);
  },
  resetRoutes({ commit, state }) {
    // 重置路由为初始状态，用户切换角色时需要用到
    state.removeRoutes.forEach(fn => fn());
    // 路由数据重置
    commit("SET_ROUTES", []);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
